import {PhoneNumberUtil, PhoneNumberFormat} from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const createTableState = () => {
    return {
        loading: false,
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    }
}

export const normalizePagination = (meta) => {
    return {
        current: meta.current_page,
        pageSize: meta.per_page,
        total: meta.total_record,
        sort: meta.sort || [],
    }
}

export const fetchByIds = async (axios, endpoint, ids) => {
    const cleanIds = [...new Set((ids || []).filter(v => v !== null && v !== undefined && v !== ''))];
    if (!cleanIds.length) return [];
    try {
        const res = await axios.get(endpoint, {
            params: {
                ids: cleanIds,
                page_limit: cleanIds.length,
            },
        });
        return res.data?.data || [];
    } catch {
        return [];
    }
}

export const walkChildren = (data, {id, children}) => {
    return data.map(row => {
        if (row.id === id) {
            row.children = children
        } else if (row.children) {
            row.children = walkChildren(row.children, {id, children})
        }
        return row
    })
}

export function formatPhone(number, defaultRegion = "TR") {
    try {
        const phoneNumber = phoneUtil.parse(number, defaultRegion);
        if (!phoneUtil.isValidNumber(phoneNumber)) {
            return number;
        }
        return phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
    } catch (e) {
        return number;
    }
}

export const formatPhonePretty = (number, defaultRegion = "TR") => {
    try {
        const phoneNumber = phoneUtil.parse(number, defaultRegion);
        if (!phoneUtil.isValidNumber(phoneNumber)) {
            return number;
        }

        const regionCode = phoneUtil.getRegionCodeForNumber(phoneNumber);

        if (regionCode === "TR") {
            const national = phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
            const match = national.match(/^0(\d{3}) (\d{3}) (\d{2}) (\d{2})$/);
            if (match) {
                return `0 (${match[1]}) ${match[2]} ${match[3]} ${match[4]}`;
            }

            return national;
        }

        return phoneUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
    } catch (e) {
        return number;
    }
}

export const getModuleByModuleId = (module_id) => {
    let modules = JSON.parse(localStorage.getItem('company_modules') || '[]');

    return modules.find(item => item.id === module_id) ?? null;
}

export const getModuleByModuleCode = (module_code) => {
    let modules = JSON.parse(localStorage.getItem('company_modules') || '[]');

    return modules.find(item => item.code === module_code) ?? null;
}

export const getModuleIdByCode = (module_code) => {
    return getModuleByModuleCode(module_code)?.id ?? null;
}